var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"text-reader"},[_vm._v("\n    Read CSV File\n    "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.loadCSVFieldsFromFile}})]),_vm._v("\n  "+_vm._s(_vm.fileName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }